import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { HomeFacade } from '@zero/home/domain';
import { TopInstrument } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { Observable } from 'rxjs';
import { MyTopInstrumentItemComponent } from '../my-top-instrument-item/my-top-instrument-item.component';

type TopInstrumentType = 'AKTIE' | 'ETF' | 'FONDS' | 'KRYPTO' | 'DERIVAT';

@Component({
  selector: 'home-my-top-instruments',
  templateUrl: './my-top-instruments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MyTopInstrumentItemComponent, RouterLink, AsyncPipe, TranslocoPipe],
})
export class MyTopInstrumentsComponent implements OnInit, OnDestroy {
  readonly #homeFacade = inject(HomeFacade);

  public topTrades: TopTrades = {
    AKTIE: this.#homeFacade.mostTradedStocks$,
    ETF: this.#homeFacade.mostTradedETFs$,
    FONDS: this.#homeFacade.mostTradedFonds$,
    KRYPTO: this.#homeFacade.mostTradedCryptos$,
    DERIVAT: this.#homeFacade.mostTradedDerivatives$,
  };
  public readonly segments: Array<TopInstrumentType> = ['AKTIE', 'ETF', 'FONDS', 'KRYPTO', 'DERIVAT'];
  public readonly cryptoOverviewPage = commonRoutes.postlogin.crypto;
  public readonly tradableProductsPage = commonRoutes.prelogin.tradeableproducts;
  public topInstrumentsSelector: TopInstrumentType = 'AKTIE';
  public searchType = this.topInstrumentsSelector[0];

  ngOnInit(): void {
    this.#homeFacade.loadTopInstruments();
    this.#homeFacade.subscribeToTopTradesQuotes();
  }

  ngOnDestroy(): void {
    this.#homeFacade.unsubscribeFromIndicesQuotes();
  }

  public changeSegment(segment: TopInstrumentType): void {
    this.topInstrumentsSelector = segment;
    this.searchType = segment[0];
  }
}

interface TopTrades {
  AKTIE: Observable<TopInstrument[]>;
  ETF: Observable<TopInstrument[]>;
  FONDS: Observable<TopInstrument[]>;
  KRYPTO: Observable<TopInstrument[]>;
  DERIVAT?: Observable<TopInstrument[]>;
}
